module.exports = __webpack_public_path__ + "img/loan_ok fin.3f0104f9.png";